// extracted by mini-css-extract-plugin
export default {"wrapperCasinoGameHeader":"CasinoGameHeaderActions_wrapperCasinoGameHeader__uyjt+","jackpotBtn":"CasinoGameHeaderActions_jackpotBtn__382Zl"};